var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.326,
    height: 19.626,
    viewBox: "0 0 19.326 19.626"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M9.663 9.586A8.673 8.673 0 0 0 1 18.249a.377.377 0 0 0 .753 0 7.91 7.91 0 0 1 15.819 0 .377.377 0 0 0 .753 0 8.67 8.67 0 0 0-8.662-8.663Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M9.663.5a4.143 4.143 0 1 0 4.143 4.143A4.15 4.15 0 0 0 9.663.5Zm0 7.533a3.39 3.39 0 1 1 3.39-3.39 3.394 3.394 0 0 1-3.39 3.39Z"
  })));
};
export default SvgUser;